import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';
import Layout from '../layouts/layout';
import { routeVerify } from '../routes/routeVerify';

const PrivateRoute = () => {
  const isAuthenticated = sessionStorage.getItem('mhet_cnd_token') || 'mhcet';
if(isAuthenticated){
  routeVerify();
}
  return isAuthenticated ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/mhcet/home" replace />
  );
};

export default PrivateRoute;
